/**
 * Small PowerPoint host guards shared by every feature's Office.js service.
 *
 * Office.js is loaded from the CDN and `PowerPoint` only exists as a global
 * when the pane runs inside PowerPoint. Checking first lets services return a
 * safe default in Word/Outlook builds and in unit tests.
 */

export function hasPpt(): boolean {
  return (globalThis as { PowerPoint?: unknown }).PowerPoint !== undefined;
}
